/**
 * Created by portiz on 8/21/2018.
 */
import ApiCalls from './api-calls';

/**
 * Validates the email, username, etc
 */
class Validator {

    /**
     * Verifies if the email seems real
     * @param email
     * @returns {boolean}
     */
    static isEmailValid(email)
    {
        let re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        //let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    /**
     * Verifies if the email is available
     * @param email The email to check
     * @param callback The callback we need
     */
    static isEmailAvailable(email, callback)
    {
        // This is promise
        let apiCall = ApiCalls.isEmailAvailable(email);
        apiCall.then(function(data){
            callback(data);
        });
    }

    /**
     * Verifies if the password are equals
     * @param password1 The password
     * @param password2 The password retype
     * @returns {boolean} false if they are not equal
     */
    static arePasswordEquals(password1, password2)
    {
        return password1 === password2;
    }

    /**
     * Verifies if the length it's valid
     * @param password The password
     * @returns {boolean} false if not valid
     */
    static isPasswordLengthValid(password)
    {
        return (password.length >= 5);
    }

    /**
     * Verifies if the length and the password are equals
     * @param password1 The password
     * @param password2 The password retype
     * @returns {boolean} false if not valid
     */
    static isPasswordValid(password1, password2)
    {
        return this.arePasswordEquals(password1, password2) && this.isPasswordLengthValid(password1);
    }

    /**
     * Verifies if the username is available
     * @param username The username to check
     * @param callback The callback
     */
    static isUsernameAvailable(username, callback)
    {
        let apiCall = ApiCalls.verifyIfUsernameIsAvailable(username);
        apiCall.then(function(data){
            callback(data);
        });
    }

    /**
     * Check if the username is valid. Set your own rules here
     * @param username The username
     * @returns {boolean} Returns true or false of valid or not
     */
    static isUsernameValid(username)
    {
        // Only letters and numbers, from a to z, A to Z and 0 to 9.
        // Doesn't include special characters or accented characters or tildes
        let re = /^([a-zA-Z0-9]+)$/;
        return re.test(String(username)) && String(username).length >= 5;
    }

    /**
     * Verifies if the address is valid
     * @param str The string to check
     * @returns {boolean} True or false according if valid or not
     */
    static isAddressValid(str)
    {
        return String(str).trim().length >= 3;
    }

    /**
     * Verifies if the city is valid
     * @param str The string to check
     * @returns {boolean} True or false according if valid or not
     */
    static isCityValid(str)
    {
        return String(str).trim().length > 0;
    }

    /**
     * Verifies if the state is valid
     * @param str The string to check
     * @returns {boolean} True or false according if valid or not
     */
    static isStateValid(str)
    {
        return String(str) !== "0" && String(str).trim().length > 0;
    }

    /**
     * Verifies if the country is valid
     * @param str The string to check
     * @returns {boolean} True or false according if valid or not
     */
    static isCountryValid(str)
    {
        return String(str) !== "0" && String(str).trim().length > 0;
    }

    /**
     * Verifies if the zip code is valid
     * @param str The string to check
     * @returns {boolean} True or false according if valid or not
     */
    static isZipCodeValid(str)
    {
        return String(str).trim().length > 0;
    }

    /**
     * Verifies if name is valid
     * @param str The string to check
     * @returns {boolean} True or false according if valid or not
     */
    static isFirstNameValid(str){
        return String(str).trim().length > 0;
    }

    /**
     * Verifies if the last name is valid
     * @param str The string to check
     * @returns {boolean} True or false according if valid or not
     */
    static isLastNameValid(str){
        return String(str).trim().length > 0;
    }

    /**
     * Verifies if the phone is valid
     * @param str The string to check
     * @returns {boolean} True or false according if valid or not
     */
    static isPhoneValid(str){
        return String(str).trim().length > 0;
    }
}

export default Validator;